module.exports = __webpack_public_path__ + "img/viral_campaign_banner_sidebar.96b91b7.png";